export const GA_HOME_FEED_CATEGORY = 'home-feed';
export const GA_HOME_CATEGORY = 'home';

// Custom Event Actions
export const GA_ONBOARDING_START_ACTION = 'StartUserOnboarding';
export const GA_LOCATION_CHANGE_ACTION = 'LocChange';
export const GA_POOR_CONTENT_ACTION = 'PoorContent';
export const GA_RUN_SEARCH_ACTION = 'RunSearch';
export const GA_RUN_SEARCH_HEADER_ACTION = 'RunSearchHeader';
export const GA_RUN_SEARCH_HEADER_RECENT = 'Recent';
export const GA_RUN_SEARCH_HEADER_POPULAR = 'Popular';
export const GA_RUN_MADLIB_SEARCH_ACTION = 'RunMadlibSearch';
export const GA_SEE_MORE_ACTION = 'SeeMore';
export const GA_SHARE_EVENT_ACTION = 'Share';
export const GA_SMALL_CITY_FALLBACK_ACTION = 'SmallCityFallback';
export const GA_SWITCH_TAB = 'SwitchTab';
export const GA_VIEW_EVENT_ACTION = 'ViewEvent';
export const GA_VIEW_EVENT_AUTOCOMPLETE = 'ViewEventAutocomplete';
export const GA_VIEW_HOMEPAGE_FEED = 'LoggedInHomePageView';
export const GA_VIEW_LOGGEDOUT_HOMEPAGE_FEED = 'LoggedOutHomePageView';
export const GA_EXPERIMENT_EXPOSURE = 'ExperimentExposure';

export const AFF_CODE_PREFIX = 'ebdshpf';

// Bookmark
export const GA_BOOKMARK_EVENT_ACTION = 'Bookmark';
export const GA_BOOKMARK_ATTEMPT_ACTION = 'BookmarkAttempt';
export const GA_UNBOOKMARK_EVENT_ACTION = 'Unbookmark';

// Follow organizer actions
export const GA_DISMISS_ORGANIZER_ACTION = 'DismissOrganizer';
export const GA_FOLLOW_ORGANIZER_ACTION = 'FollowOrganizer';
export const GA_SHOW_ORGANIZERS_ACTION = 'OrganizersShown';
export const GA_VIEW_ORGANIZER_PROFILE_ACTION = 'ViewOrganizerProfile';

// Five to Follow actions
export const GA_BUCKET_LOADED_ACTION = 'BucketLoaded';
export const GA_NEXT_SLIDE_ACTION = 'NextSlide';
export const GA_PREVIOUS_SLIDE_ACTION = 'PreviousSlide';
export const GA_SLIDES_LIMIT_REACHED_ACTION = 'SlidesLimitReached';

// Share
export const TRACKING_CODE = 'abc';
export const GA_SHARE_ATTEMPT = 'ShareAttempt';

// UTM
export const UTM_HOME_FEED_TERM = 'homefeed';
export const UTM_HOME_TERM = 'home';

// Browse Arrow
export const GA_BROWSE_ARROW = 'BrowseArrow';
export const GA_BROWSE_ARROW_LABEL = 'BrowseOtherPopularEvents';

// Seasonal
export const GA_HOME_BANNER_CTA_CLICK = 'HomeBannerCTAClick';

// Editorial collection
export const GA_CLICK_VIEW_ONLINE_COLLECTION_ACTION =
    'ViewEditorialOnlineCollection';
export const GA_TRANSITION_ONLINE_COLLECTION = 'TransitionOnlineCollection';

// Unsure what this constant is for, just adding it to fix an import lint error
// since it was being imported but not defined
export const GA_HOME_V2_LABEL_CUSTOM_DATE = 'CustomDate';
